import script from "./MotivatesList.vue?vue&type=script&setup=true&lang=js"
export * from "./MotivatesList.vue?vue&type=script&setup=true&lang=js"

import "./MotivatesList.vue?vue&type=style&index=0&id=709eb4b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709eb4b6"]])

export default __exports__